import { Info } from "lucide-react";
import { UPLOAD_LIMITS, fmt } from "../../lib/limits";

// Small info banner shown on every upload page BEFORE file selection.
export function UploadLimitBanner({ kind, className = "" }) {
  const limit = UPLOAD_LIMITS[kind];
  if (!limit) return null;
  return (
    <div data-testid={`upload-limit-${kind}`} className={`mb-4 flex items-start gap-2 rounded-md border border-blue-200 bg-blue-50 px-3 py-2 text-xs text-blue-800 ${className}`}>
      <Info className="mt-0.5 h-3.5 w-3.5 shrink-0" />
      <span>
        <b>Maximum {fmt(limit)} rows per file.</b> For larger data, please split the Excel into multiple files and upload again.
      </span>
    </div>
  );
}
